/* eslint-disable new-parens */
/* eslint-disable camelcase */
import Choices from 'choices.js'
import Vue from 'vue'
import AjaxAPI from '../helpers/AjaxAPI'
import {getPrice} from '../helpers/shopify'
import log from 'salvo-lite/log'

Vue.config.ignoredElements = ['klarna-placement', 'o:p']

class ProductPicknmix {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._data = {
            ...JSON.parse(elem.innerHTML || '{}')
        }
        this._DOMSelectors = {
            quantityWrapper: '[data-quantity-wrapper]',
            quantityInput: '[data-quantity-input]'
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        this._vue()
    }

    _vue () {
        const vue = new Vue({
            el: '[data-product-picknmix-main]',
            data: {
                editing: false,
                isInCart: false,
                bundleId: null,
                ...this._getData()
            },
            delimiters: ['${', '}'],
            mounted () {
                const transparentEl = this.$el.querySelector('.product__picknmix-main')
                transparentEl.classList.remove('transparent')
                this.choicesJS()
                this.getVariantQuantity()
                this.checkIfInCart()
            },
            computed: {
                selectedVariant () {
                    return this.product.variants.find(variant => {
                        let match = true
                        for (let i = 0; i < this.product.options.length; i++) {
                            const optionKey = `option${i + 1}`
                            if (variant[optionKey] !== this.selectedOptions[optionKey]) match = false
                        }
                        return match
                    })
                },
                featuredImage () {
                    return this.selectedVariant.title === '24 Bar Box' ? this.product.images[1] : this.product.images[2]
                },
                maxItems () {
                    return parseInt(this.selectedVariant.title)
                },
                selectedItemCount () {
                    let totalSelectedItems = 0
                    for (const itemID in this.selectedItems) {
                        totalSelectedItems += this.selectedItems[itemID].count
                    }
                    return totalSelectedItems
                },
                maxItemsReached () {
                    return this.selectedItemCount >= this.maxItems
                },
                maxItemsExceeded () {
                    return this.selectedItemCount > this.maxItems
                },
                twelveBarVariant () {
                    return this.product.variants.find(variant => variant.title.includes('12')) || null
                }
            },
            filters: {
                money (price) {
                    return getPrice(price)
                }
            },
            methods: {
                checkIfInCart () {
                    const mainItem = this.cart.items.find(item => item.product_title.includes(`Pick'N'Mix`))

                    if (!mainItem) return

                    this.isInCart = true

                    for (let i = 0; i < this.cart.items.length; i++) {
                        const item = this.cart.items[i]
                        if (item.handle !== 'grenade-carb-killa' || !item.properties.picknmix) continue
                        if (!this.selectedItems[item.variant_id]) continue

                        this.selectedItems[item.variant_id].count = item.quantity
                        this.bundleId = item.properties._bundle_id

                        for (let j = 0; j < item.quantity; j++) {
                            this.updateImages(true, item.variant_id)
                        }
                    }
                },
                getVariantQuantity () {
                    this.variantQuantity.forEach(item => {
                        const variantIndex = this.childProductVariants.findIndex(variant => variant.id === item.id)
                        const cartIndex = this.cart.items.findIndex(lineItem => lineItem.id === item.id)
                        const inCart = cartIndex !== -1 ? this.cart.items[cartIndex].quantity : 0
                        const quantity = item.quantity - inCart

                        this.childProductVariants[variantIndex] = { ...this.childProductVariants[variantIndex], quantity }
                        this.$forceUpdate()
                    })
                },
                choicesJS () {
                    const options = {
                        searchEnabled: false,
                        removeItems: false,
                        itemSelectText: '',
                        shouldSort: false,
                        classNames: {
                            containerOuter: 'choices product__mobile-quantity'
                        }
                    }
                    const choicesElement = this.$refs['choices']
                    if (!choicesElement) return
                    window.choices = new Choices(choicesElement, options)
                    choicesElement.addEventListener('input', e => {
                        this.$emit('input', e.target.value)
                    })
                },
                getVariantTitle (variant) {
                    return variant[this.titleVariantOption].split('-')[0]
                },
                getVariantColour (variant) {
                    return this.childProductSwatchColours[variant.id]
                },
                addItem (e, variant) {
                    if (this.maxItemsReached) return
                    this.selectedItems[variant.id].count += 1
                    this.updateImages(true, variant.id)
                },
                removeItem (e, variant) {
                    const quantityInputElement = e.target.closest(this.DOMSelectors.quantityWrapper).querySelector(this.DOMSelectors.quantityInput)
                    if (parseInt(quantityInputElement.value) === 0) return
                    this.editing = true
                    this.selectedItems[variant.id].count -= 1
                    this.updateImages(false, variant.id)
                },
                updateImages (added, id) {
                    if (added) {
                        this.imagesArray.push(this.selectedItems[id].image)
                    } else {
                        const index = this.imagesArray.lastIndexOf(this.selectedItems[id].image)
                        if (index === -1) return
                        if (index === this.imagesArray.length - 1) {
                            this.imagesArray.pop()
                        } else {
                            this.imagesArray.splice(index, 1)
                        }
                    }
                },
                async updateCart (e) {
                    const payload = {}
                    this.cart.items.forEach(item => {
                        if (item.properties['_bundle_id'] === this.bundleId) {
                            payload[item.key] = 0
                        }
                    })
                    await AjaxAPI.updateItems(payload)

                    this.editing = false

                    this.addToCart()
                },
                async addToCart (e) {
                    if (this.editing) return this.updateCart(e)

                    const _bundle_id = Number(new Date) % 1000000
                    this.bundleId = _bundle_id
                    const picknmixItems = []
                    for (let variantID in this.selectedItems) {
                        if (this.selectedItems[variantID].count > 0) {
                            picknmixItems.push({
                                id: parseInt(variantID),
                                quantity: this.selectedItems[variantID].count,
                                properties: {
                                    'picknmix': 1,
                                    'bundleTitle': this.product.bundleTitle,
                                    _bundle_id
                                }
                            })
                        }
                    }
                    const payload = {
                        items: [
                            {
                                id: this.selectedVariant.id,
                                quantity: 1,
                                properties: {
                                    'picknmix': 1,
                                    'bundleTitle': this.product.bundleTitle,
                                    _bundle_id
                                }
                            },
                            ...picknmixItems
                        ]
                    }

                    const response = await AjaxAPI.addItem(payload)
                    this.cart = response.cart.data
                    this.isInCart = true
                }
            }
        })

        window.vueJob = vue
    }

    _getData () {
        const DOMSelectors = this._DOMSelectors
        const { product, childProduct, childProductVariantIds, childProductSwatchColours, titleVariantOption, variantPrices, variantQuantity } = this._data
        const childProductVariants = childProduct.variants.filter(variant => childProductVariantIds.includes(variant.id))
        const cartJSON = JSON.parse(document.querySelector('[data-cart-json]').innerHTML)

        const imagesArray = []
        const selectedItems = {}
        childProductVariants.forEach(variant => {
            selectedItems[variant.id] = { count: 0, image: variant.featured_image.src }
        })

        const selectedOptions = {}
        for (let i = 0; i < product.options.length; i++) {
            const optionKey = `option${i + 1}`
            selectedOptions[optionKey] = '24 Bar Box'
        }
        return { cart: cartJSON.cart, DOMSelectors, product, childProduct, variantQuantity, childProductVariants, childProductSwatchColours, titleVariantOption, variantPrices, imagesArray, selectedItems, selectedOptions }
    }
}

export default ProductPicknmix



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductPicknmix.js